import { Children, useEffect, useState } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { ModalDeleteCore, TableCore, TdCore } from "src/Pages/components";
import { AddIcon, DeleteForeverIcon, FolderCopyIcon } from "src/Pages/components/Icons/Icons";

import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { TableRowCore } from "src/Pages/components/table/@Core/TableRowCore/TableRowCore";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";

import { useHttpTableContractsFiles } from "./Hooks/useHttpTableContractsFiles";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { Box, Chip, IconButton, Typography } from "@mui/material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { getFileSize } from "src/shared/Utils/getFileSize";
import { IconImagePreview } from "src/Pages/components/CardPreviewFile/CardPreviewFile";
import { THeadContractsFiles } from "./THead";
import { ModalContractsFiles } from "./Form/indexForm";

interface ITableContractsFiles {
  idContract?: string;
}

export const TableContractsFiles = ({
  idContract: id,
}: ITableContractsFiles) => {
  const { listContractsFiles } = useContextContrato();

  const { attTable } = useConfigPageContext();
  const { handleGet } = useHttpTableContractsFiles({
    contractId: id,
  });

  const [openModalContractsFiles, setOpenModalContractsFiles] = useState(false);

  useEffect(() => {
    handleGet();
  }, [attTable]);

  if (!id) return null;

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({
    url: `/contracts-files`,
  });

  return (
    <TableCore
      isNotPagination
      Modals={
        <>
          <ModalContractsFiles
            openModal={openModalContractsFiles}
            setOpenModal={setOpenModalContractsFiles}
            id={id}
          />
          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja excluir da lista ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={() => handleDelete()}
          />
        </>
      }
      THead={<THeadContractsFiles />}
      qtdList={listContractsFiles.length}
      cardAdd={{
        icon: <FolderCopyIcon fontSize="small" />,
        title: "Arquivos",
        buttonAdd: [
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Chip
              label={`Total de arquivos: ${listContractsFiles.length}`}
              color="primary"
              variant="outlined"
              size="small"
            />
            <ButtonCore
              size="small"
              startIcon={<AddIcon />}
              title="Anexar arquivos"
              onClick={() => setOpenModalContractsFiles(true)}
            />
          </Box>,
        ],
      }}
    >
      {Children.toArray(
        listContractsFiles.map((item) => {
          return (
            <TableRowCore id={String(item.id)}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        icon: <RemoveRedEyeIcon fontSize="small" />,
                        title: "Visualizar",
                        onClick: () => {
                          window.open(item.url, "_blank");
                        },
                      },
                      {
                        icon: <DeleteForeverIcon fontSize="small" />,
                        title: "Excluir",
                        background: "error",
                        onClick: () => {
                          setIdModalDelete(item.id);
                          setOpenModalDelete(true);
                        },
                      },
                    ]}
                  />
                }
              />
              <TdCore
                values={
                  <Box
                    sx={{ display: "flex", alignItems: "center" }}
                    onClick={() => window.open(item.url, "_blank")}
                  >
                    <IconImagePreview type={item.mime_type} url={item.url} />
                    <Typography>{item.original_name}</Typography>
                  </Box>
                }
              />
              <TdCore values={getFileSize(item.size)} />
              <TdCore values={FormatDateBR(item.created_at)} />

              <TdCore
                textAlign="center"
                onClick={() => window.open(item.url, "_blank")}
                values={
                  <IconButton>
                    <RemoveRedEyeIcon
                      sx={{ color: (theme) => theme.palette.primary.main }}
                    />
                  </IconButton>
                }
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
